import { cloneDeep } from "lodash-es";
import { FITDATAIDS } from "../fitData/consts";
export function getAnyDataSchema() {
  const entitySchema = this.getEntitySchema();
  const schema = entitySchema ? cloneDeep(entitySchema) : {
    type: 'any'
  };
  schema.id = 'data';
  schema.title = '响应data';
  schema['ds:fitDataId'] = FITDATAIDS.anyData;
  return schema;
}
export function getAnyQuerySchema() {
  const entitySchema = this.getEntitySchema();
  const schema = entitySchema ? cloneDeep(entitySchema) : {
    type: 'any'
  };
  schema.id = 'data';
  schema.title = '响应data';
  return schema;
}
export function getAnyStateFeatures(state) {
  var _state$options$source;
  const configVersion = Number((_state$options$source = state.options.sourceConfig) === null || _state$options$source === void 0 ? void 0 : _state$options$source.configVersion) || 1;
  return {
    hostRequestParams: configVersion >= 2
  };
}
//# sourceMappingURL=any.js.map
